// extracted by mini-css-extract-plugin
export default {"offerer":"offerer--z6MuG","offerer__title":"offerer__title--ujzuY","offererTitle":"offerer__title--ujzuY"};